<script setup lang="ts">
import { computed, reactive, watch } from '#imports';
import { UiIllustrationName, UiIconIllustration } from '../icon';

const props = withDefaults(defineProps<{
  src?: string;
  size?: string;
  cover?: boolean;
  loading?: HTMLImageElement['loading'];
  qa?: string;
}>(), {
  src: '',
  size: '100%',
  cover: false,
  loading: 'lazy',
  qa: '',
});

const styles = computed(() => {
  switch (props.size) {
    case 'maxWidth':
      return { width: '100%' };
    case 'maxHeight':
      return { height: '100%' };
    default:
      return { width: props.size, height: props.size };
  }
});

watch(() => props.src, () => {
  state.error = false;
  state.loaded = false;
});

const state = reactive({
  error: false,
  loaded: false,
});
</script>

<template lang="pug">
UiIconIllustration.no-image-icon(v-if="state.error || !src" data-qa="image-error" loading="eager" :name="UiIllustrationName.NoImage" :size="size")
img.img(
  v-else
  :loading="loading"
  :src="src"
  :style="styles"
  :class="{'object-fit-cover': cover, 'object-fit-contain': !cover, loading: !state.loaded }"
  :data-qa="state.loaded ? (qa || src) : 'image-loader'"
  @error="state.error = true"
  @load="state.loaded = true"
)
</template>

<style lang="scss" scoped>
.loading {
  background-image: url('/loader.svg');
}
</style>
